import PropTypes from 'prop-types';
import styled from 'styled-components';

export const GridRow = styled.div`
  grid-column: 1 / -1;
  grid-row-start: ${props => props.row};

  /* Fallback for browsers without grid support */
  flex: 1 0 100%;
  order: 1;
`;

const { number, node } = PropTypes;

GridRow.propTypes = {
  children: node,
  row: number,
};

GridRow.defaultProps = {
  children: undefined,
  row: 1,
};
